import React from "react";
import user from "../../../_assets/images/users/user_1.jpg";
import { map } from "lodash";
import { getRelativeTime } from "../../../_utils";

const AdvancedTimeline = ({ items }) => {
  return (
    <div class="timeline">
      {map(items, (item, index) => {
        let _classes = ["timeline-item"];
        if ((index + 1) % 2 === 0) {
          _classes.push("timeline-item-even");
        }
        if (item.style) {
          _classes.push(`timeline-item-${item.style}`);
        }
        if (item.button) {
          _classes.push("timeline-item-buttons");
        }
        return (
          <div className={_classes.join(" ")}>
            <div className="timeline-item-date">
              {getRelativeTime(item.time)}
            </div>
            <div className="timeline-item-image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="timeline-item-data">
              <h4 style={{ textTransform: "capitalize" }}>{item.title}</h4>
              <p className="text-muted">{item.label}</p>
            </div>
            {item.button ? (
              <div className="timeline-item-button">{item.button}</div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default AdvancedTimeline;



// WEBPACK FOOTER //
// ./src/_components/UI/AdvancedTimeline/index.js